import {BaseComponent} from './base-component.js'
import {customElement} from 'lit/decorators.js'
import {html, css} from 'lit'

@customElement('il-static-footer')
export default class StaticFooterComponent extends BaseComponent {
  static override styles = [
    BaseComponent.styles,
    css`
      .il-static-footer-container {
        --il-static-footer-height: 62px;
        --il-static-footer-border-color: var(--il-color-neutrals-100);
        --il-static-footer-padding: 16px;

        padding: var(--il-static-footer-padding);
        height: var(--il-static-footer-height);
        background-color: var(--il-static-footer-background-color, var(--il-color-neutrals-50));
        border-top: 1px solid var(--il-static-footer-border-color);

        display: flex;
        align-items: center;

        width: 100%;
      }

      .il-static-footer {
        display: flex;
        align-items: center;
        width: 100%;
      }
    `,
  ]

  override render () {
    return html`
      <div
        class="${this.baseCSSClass} il-static-footer-container"
        data-test-iliad-static-footer-container
      >
        <div class="il-static-footer" data-test-iliad-static-footer>
          <slot name="left-side"></slot>
          <slot name="right-side"></slot>
        </div>
      </div>
    `
  }
}
